window.onload = function() {
    document.querySelector('.wrapper').style.display = 'none';
};
var x = ["printf(\"Hello world!!\")","cout << \"Hello world!!\"","System.out.println(\"Hello world!!\")","print(\"Hello world!!\")"]
var i = 0;
setInterval(() => {
    i = (i+1)%4
    document.querySelector('.loader p').innerHTML = x[i]
}, 500);